export default "__VITE_ASSET__DfSy0UZg__"